import styled from 'styled-components'

import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'
import { FooterThemeModeType } from '@src/Application/Types/ComponentTypes'

export const Description = styled.div`
    ${(props) => props.theme.typo.bodyS}

    padding: 30px 20px 30px 0px;
`

export const Title = styled.div`
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.bold}

    padding-bottom: 7px;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.bodyL}
    }
`

export const Separator = styled.div`
    width: 100%;
    height: 1px;
    background: ${(props) => props.theme.color.g500};
`

export const WrapperContent = styled.div`
    margin: 0 auto;
    max-width: 1170px;
    width: 100%;

    & + ${Separator} {
        margin-top: 70px;
    }
`

export const Link = styled(LinkBase)`
    ${(props) => props.theme.typo.bodyS}
    ${(props) => props.theme.fontWeight.regular};

    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`

export const CountryLabel = styled.span`
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.bold}
`

export const PhoneNumber = styled.span`
    ${(props) => props.theme.typo.bodyM}
`

export const ItemWrapper = styled.div`
    padding: 7px 0px;
`

export const MinimalSocialLinksWrapper = styled.div`
    a {
        margin: 0px 15px;
    }
`

export const MinimalCopyrightWrapper = styled.div`
    ${(props) => props.theme.typo.bodyS}

    align-items: center;
    text-align: center;
    padding-top: 5px;
    padding-bottom: 5px;

    a {
        margin: 0px 15px;
    }
`

export const CopyrightWrapper = styled(MinimalCopyrightWrapper)`
    height: 97px;

    @media ${(props) => props.theme.query.min.tablet} {
        text-align: left;
        padding: 0;
        height: 87px;
    }
`

export const SocialLinkWrapper = styled.div`
    text-align: center;

    @media ${(props) => props.theme.query.min.tablet} {
        text-align: right;
    }
`

export const Wrapper = styled.div<{ $mode: FooterThemeModeType }>`
    width: 100%;
    padding-top: 50px;

    ${(props) => props.$mode === 'Dark' && `background: ${props.theme.color.p600};`}
    ${(props) => props.$mode === 'Light' && `background: ${props.theme.color.white};`}
    ${(props) => props.$mode === 'Neutral' && `background: ${props.theme.color.g200};`}

    ${Description}, ${Title}, ${Link}, ${CountryLabel}, ${PhoneNumber}, ${CopyrightWrapper} {
        ${(props) => props.$mode === 'Dark' && `color: ${props.theme.color.white};`}
        ${(props) => props.$mode === 'Light' && `color: ${props.theme.color.g500};`}
        ${(props) => props.$mode === 'Neutral' && `color: ${props.theme.color.g500};`}
    }
`

export const MinimalFooterWrapper = styled.div<{ $mode: FooterThemeModeType }>`
    text-align: center;
    padding: 50px 0px;

    ${(props) => props.$mode === 'Dark' && `background: ${props.theme.color.p600};`}
    ${(props) => props.$mode === 'Light' && `background: ${props.theme.color.white};`}
    ${(props) => props.$mode === 'Neutral' && `background: ${props.theme.color.g200};`}

    ${MinimalCopyrightWrapper} {
        ${(props) => props.$mode === 'Dark' && `color: ${props.theme.color.white};`}
        ${(props) => props.$mode === 'Light' && `color: ${props.theme.color.g500};`}
        ${(props) => props.$mode === 'Neutral' && `color: ${props.theme.color.g500};`}
    }
`

export const LogoWrapper = styled.div`
    @media ${(props) => props.theme.query.mobile} {
        justify-content: center;
        display: flex;
    }
`
